<script>
  import { createEventDispatcher } from "svelte";
  import { Icon } from "svelte-hero-icons";
  import { tooltip } from "$utils/tooltip";
  import { keyConfig } from "$utils/keyConfig";

  export let value = [];
  export let label = "";
  export let isReadonly = false;

  const dispatch = createEventDispatcher();

  $: selectedCount = value.length;
  $: totalCount = keyConfig.length;

  function toggleKey(key) {
    if (isReadonly) return;

    const newValue = value.includes(key) ? value.filter((v) => v !== key) : [...value, key];

    dispatch("input", newValue);
  }

  function selectAll() {
    if (isReadonly) return;
    dispatch(
      "input",
      keyConfig.map((k) => k.key),
    );
  }

  function clearAll() {
    if (isReadonly) return;
    dispatch("input", []);
  }
</script>

<div class="w-full mb-2">
  <div class="flex items-center justify-between mb-1.5">
    <span class="text-xs font-medium text-content">{label}</span>
    <div class="flex gap-1">
      <button
        type="button"
        on:click={selectAll}
        disabled={isReadonly}
        class="text-[10px] px-1.5 py-0.5 rounded text-blue-600 hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        All
      </button>
      <button
        type="button"
        on:click={clearAll}
        disabled={isReadonly}
        class="text-[10px] px-1.5 py-0.5 rounded text-content-muted hover:bg-surface-hover disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        None
      </button>
    </div>
  </div>

  <div class="flex flex-wrap gap-2 mb-2">
    {#each keyConfig as { key, icon, label: keyLabel }}
      <button
        use:tooltip
        aria-label={keyLabel}
        type="button"
        on:click={() => toggleKey(key)}
        disabled={isReadonly}
        class="p-1 rounded-md transition-all focus:outline-none focus:ring-2 {value.includes(key)
          ? 'bg-blue-600 text-white shadow-md focus:ring-blue-400'
          : 'bg-surface-muted text-content shadow-sm focus:ring-line-strong hover:bg-surface-hover'} {isReadonly
          ? 'cursor-not-allowed opacity-50'
          : 'cursor-pointer active:shadow-sm active:translate-y-0.5'}"
      >
        {#if typeof icon === "string"}
          <span class="w-4 h-4 flex items-center justify-center text-sm font-normal">{icon}</span>
        {:else}
          <Icon src={icon} class="w-4 h-4" />
        {/if}
      </button>
    {/each}
  </div>

  {#if selectedCount > 0}
    <div class="mt-1.5 text-[10px] text-content-subtle">
      {selectedCount} of {totalCount} selected
    </div>
  {/if}

  <slot name="dynamic" />
</div>
